import { useState } from 'react';
import Button from '../../components/admin/ui/Button';
import '../../css/admin/login.css';

function AdminLogin({ onLogin, isAuthenticating, authError }) {
  const [password, setPassword] = useState('');

  return (
    <div className="admin admin-login">
      <div className="admin-login-mark">
        <img src="/logo_BJ/Logo_BJ_v2%20noir.png" alt="Logo" />
      </div>
      <div className="admin-login-card">
        <h2>Zone sécurisée</h2>
        <p>Merci d'entrer le mot de passe administrateur.</p>
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onLogin(password)}
        />
        <Button onClick={() => onLogin(password)} disabled={isAuthenticating}>
          {isAuthenticating ? 'Vérification...' : 'Se connecter'}
        </Button>
        {authError && <p className="admin-error">{authError}</p>}
      </div>
    </div>
  );
}

export default AdminLogin;
